export default __webpack_public_path__ + "static/media/cover-pc.914c507a.jpg";